interface BarraProgressoProps {
  total: number; // 2 ou 3 etapas
  ativa: number; // índice (0-based) da etapa ativa
}

const NOMES = ['Participante', 'Ficha', 'Pronto'];

export default function BarraProgresso({ total, ativa }: BarraProgressoProps) {
  const etapas = total === 2 ? ['Participante', 'Pronto'] : NOMES;

  return (
    <div className="flex items-start gap-3">
      {etapas.map((nome, i) => {
        const preenchida = i <= ativa;
        return (
          <div key={nome} className="flex-1">
            <div
              className={`h-1.5 w-full rounded-full ${
                preenchida ? 'bg-primary-500' : 'bg-secondary-200'
              }`}
            />
            <span
              className={`mt-1.5 block text-xs ${
                preenchida ? 'font-medium text-primary-600' : 'text-secondary-500'
              }`}
            >
              {nome}
            </span>
          </div>
        );
      })}
    </div>
  );
}